import { render, staticRenderFns } from "./PredictiveAnalysis.vue?vue&type=template&id=2147974e&"
import script from "./PredictiveAnalysis.vue?vue&type=script&lang=js&"
export * from "./PredictiveAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2147974e')) {
      api.createRecord('2147974e', component.options)
    } else {
      api.reload('2147974e', component.options)
    }
    module.hot.accept("./PredictiveAnalysis.vue?vue&type=template&id=2147974e&", function () {
      api.rerender('2147974e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wla/PredictiveAnalysis.vue"
export default component.exports